import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";

export const Route = createFileRoute("/_default/terms")({
  component: RouteComponent,
});

function RouteComponent() {
  return <LegalPage titleKey="legal_terms_title" bodyKey="legal_terms_body" />;
}
